import $ from 'jquery'

import Popup from '../popup'
import * as blocks from '../'
import run from '../../scripts/run'

export default class ShoppingcartPopup extends Popup {
	static title = 'shoppingcart-popup'

	constructor($el) {
		super($el)

		$(document).on('product:add', (event, data) => this.render(data))
		$(document).on('nav:open-shoppingcart', () => this.viewCart())
		$(document).on('overlay:close', () => {
			this.$el.addModifier('hidden')
		})

		this.$el.findElement('back-button').on('click', () => {
			super.close()
		})

		this.$el.on('change', 'form', (event) => this.handleFormChange(event))

		if (performance.navigation.type == 2) {
			this.loadShoppingcart()
		}
	}

	render(data) {
		super.open()

		this.$el.removeModifier('hidden')

		$('.nav__item[data-shoppingcart] .nav__count').text(data.count)

		this.$el.findElement('product-count').text(data.count)
		this.$el.findElement('promotion').text(`- € ${data.promotion.toFixed(2)}`)
		this.$el.findElement('total').text(`€ ${data.total.toFixed(2)}`)
		this.$el.findElement('shipping').text(`€ ${data.shipping.toFixed(2)}`)
		this.$el
			.findElement('producttotal')
			.text(`€ ${data.producttotal.toFixed(2)}`)
		this.$el.findElement('content').html(data.html)

		run(blocks, this.$el.findElement('content'))
	}

	setLoading(loading) {
		if (loading) {
			this.$el.addModifier('loading')
		} else {
			this.$el.removeModifier('loading')
		}
	}

	viewCart() {
		this.open()
		$(document).trigger('shoppingcart:view-cart')
	}

	handleFormChange(event) {
		this.setLoading(true)

		const $form = $(event.target).parents('form')
		const data = new FormData($form.get(0))
		data.append('ajax', true)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: $form.attr('action'),
			data: data,
		})
			.done((json) => this.render(json))
			.fail((error) => {
				$(document).trigger('message:error', error.message)
			})
			.always(() => this.setLoading(false))
	}

	loadShoppingcart() {
		const data = new FormData()
		data.append('shoppingcart_load', true)
		data.append('ajax', true)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/shoppingcart',
			data: data,
		})
			.done((json) => this.changePopupData(json))
			.fail((error) => {
				$(document).trigger('message:error', error.message)
			})
	}

	changePopupData(data) {
		this.$el.findElement('product-count').text(data.count)
		this.$el.findElement('promotion').text(`- € ${data.promotion.toFixed(2)}`)
		this.$el.findElement('total').text(`€ ${data.total.toFixed(2)}`)
		this.$el.findElement('shipping').text(`€ ${data.shipping.toFixed(2)}`)
		this.$el
			.findElement('producttotal')
			.text(`€ ${data.producttotal.toFixed(2)}`)
		this.$el.findElement('content').html(data.html)

		$('.nav__item[data-shoppingcart] .nav__count').text(data.count)

		run(blocks, this.$el.findElement('content'))
	}
}
